import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import Menu from "../assets/icons/menudots.svg";
import MenuWhite from "../assets/icons/MenuWhite.svg";
import Logo from "../assets/images/logo.svg";
import MenuBox from "../components/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [menu, setMenuActive] = useState(false);
  const [color, setColor] = useState(false);
  return (
    <div>
      <Box sx={{ height: "100vh", width: "100vw" }}>
        {!menu && (
          <Box sx={{ height: "100vh", width: "100vw" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "calc(100% - 60px)",
                position: "fixed",
                top: "10px",
                padding: "30px",
                zIndex: 1000,
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                onClick={() => navigate("../home")}
                sx={{
                  display: "flex",
                  height: {
                    xs: "140px", // Extra small screen
                    md: "140px", // Medium screen
                    lg: "120px", // Large screen
                  },
                  cursor: "pointer",
                }}
              >
                <img
                  src={Logo}
                  style={{
                    height: "100%", // Make the image scale to parent height
                    width: "auto", // Keep aspect ratio
                    objectFit: "contain", // Optional: Ensures it doesn’t overflow
                  }}
                  alt="Logo"
                />
              </Box>
              <Box
                onClick={() => {
                  setMenuActive(true);
                }}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginRight: {
                    xs: "0px", // Extra small screen
                    md: "10px", // Medium screen
                    lg: "40px", // Large screen
                  },
                  marginBottom: { lg: "80px", xs: "10px" },

                  cursor: "pointer",
                }}
              >
                <Typography
                  sx={{
                    marginRight: "5px",
                    color: { md: color ? "#ffffff" : "#F04336", xs: "#F04336" },
                    fontFamily: "Nunito",
                    fontWeight: "850",
                    fontSize: { xs: "28px", md: "28px" },
                  }}
                >
                  Menu
                </Typography>
                {!isTablet && (
                  <img
                    style={{
                      height: "19px",
                    }}
                    src={!isTablet ? (color ? MenuWhite : Menu) : Menu}
                    alt="Menu"
                  />
                )}
              </Box>
            </Box>
            <Outlet context={[color, setColor]} />
          </Box>
        )}{" "}
        {menu && <MenuBox setMenuActive={setMenuActive} setColor={setColor} />}
      </Box>
    </div>
  );
};

export default DashboardLayout;
